export default __webpack_public_path__ + "static/media/timg.8882e2cc.jpg";